import React from "react"
import Image from "gatsby-image"
import { Link } from "gatsby"
import { graphql, useStaticQuery } from "gatsby"
import SocialLinks from "../constants/socialLinks"


const Hero = () => {

  const {
    file:{
      childImageSharp: { fluid },
    },
  } = useStaticQuery(query)
  
  return <header className="hero">
    <div className="section-center hero-center">
      <article className="hero-info">
        <div>
          <h2>I AM AKHADAM AYOUB</h2>
          <h4>Back end developer and data science student</h4>
          <Link to="projects" className="btn btn-s">SEE MY WORK</Link>
          <SocialLinks />
        </div>
      </article>
      <Image fluid={fluid} className="hero-img" />
    </div>
  </header>
}

export default Hero
export const query = graphql`
{
  file(relativePath: {eq: "banner.png"}) {
    childImageSharp {
      fluid {
        ...GatsbyImageSharpFluid
      }
    }
  }
}
`
 